import React from 'react';
import { Row, Col, Table } from "reactstrap";

const DadosAutoridadeMarc = props => {

    const gerarConteudoCampo = (paragrafo, seqPar, idx) => {
        let content = [];
        //? Itera sobre os arrays, usa o tamanho do array da descricao como base 
        for (let contSeqSecao = 0; contSeqSecao < seqPar.descricao.length; contSeqSecao++) {
            let secao = seqPar.secao[contSeqSecao];
            let descricao = seqPar.descricao[contSeqSecao];
            let pontuacao = seqPar.pontuacao[contSeqSecao];
            content.push(
                <span key={`info__${paragrafo}${contSeqSecao}`}>
                    {`${secao} ${descricao}${pontuacao}`}
                </span>
            );
        }
        return <div key={`seqPar${idx}`}>
            {content}
        </div>;
    }

    return (
        <Row className="pad5 animated fadeIn">
            <Col xs="12" md="12">
                <Table striped className="animated fadeIn">
                    <tbody>
                        {props.dados.map((row) => (
                            <tr key={`row-par${row.paragrafo}`}>
                                <td className="p-2 s14 font-weight-bold">{("000" + row.paragrafo).slice(-3)}</td>
                                <td className="p-2 umaLinha3p s14 font-weight-bold">
                                    {`${row.indicador1}   ${row.indicador2}`}
                                </td>
                                <td style={{ wordBreak: 'break-all' }} className="s13 p-2 text-justify">
                                    {row.seq_paragrafos.map((seqPar, idx) => gerarConteudoCampo(row.paragrafo, seqPar, idx))}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Col>
        </Row>
    )
}

export default DadosAutoridadeMarc;